import * as pkgInfo from "../../../package.json"

export const version = pkgInfo.version

export default version
